import { v4 as uuidv4 } from "uuid";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getFontSizeOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "footer",
  props: {
    logo: {
      prop: "other",
      type: "boolean",
      value: false,
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        color: getColorOptions(defaultStyles.content.color),
        fontSize: getFontSizeOptions(defaultStyles.content.fontSize),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
